import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Shared skeleton fragments for the raw-footage browse pending states, kept in
 * sync with the real markup (bordered rows, the `space-y-1` detail header) so
 * the placeholder and the loaded content don't drift.
 */

/** A list of bordered placeholder rows matching the browse link rows. */
export function BrowseSkeletonRows({ count }: { count: number }) {
  return (
    <ul className="space-y-2">
      {Array.from({ length: count }, (_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder rows, no identity
        <li key={i} className="rounded-md border border-border p-3">
          <Skeleton className="h-5 w-56" />
        </li>
      ))}
    </ul>
  );
}

/** Placeholder for a detail header (back-link, title, subtitle). */
export function BrowseSkeletonHeader() {
  return (
    <header className="space-y-1">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-7 w-64" />
      <Skeleton className="h-4 w-40" />
    </header>
  );
}
